/**
 * Centralized registry of all backend API endpoints.
 * Matches the structure of backend/config.py.
 */

export const API_BASE_URL = "https://dev-api.xeroalpha.com/api";
export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/login",
    REFRESH: "/refresh",
  },
  LEADS: {
    ROOT: "/leads",
    BULK_IMPORT: "/leads/bulk-import",
    STAGE: (id: string) => `/leads/${id}/stage`,
    HISTORY: (id: string) => `/leads/${id}/history`,
  },
  CRM: {
    CAMPAIGNS: "/campaigns",
    CAMPAIGNS_SEND: "/campaigns/send",
  },
  SUPERADMIN: {
    CLIENTS: "/superadmin/clients",
    CUSTOMERS: "/superadmin/customers",
    ACCESS_CONTROL: "/superadmin/access-control",
    GROUPS: "/superadmin/groups",
    MODULES: "/superadmin/modules",
  },
  AUTODIALER: {
    CAMPAIGNS: "/auto-dialer/campaigns",
    CONTACTS: "/auto-dialer/contacts",
    DIAL: (id: string) => `/auto-dialer/dial/${id}`,
  },
  BULK_COMMUNICATION: {
    CAMPAIGNS: "/bulk-communication/campaigns/",
    CREATE_FROM_DATA: "/bulk-communication/campaigns/send/",
    CAMPAIGNS_SEND: "/bulk-communication/campaigns/trigger-dispatch/",
    BULK_SMS: "/notifications/sms/bulk-upload/",
    BULK_WHATSAPP: "/notifications/whatsapp/bulk-upload/",
    DIRECT_SMS: "/bulk-communication/campaigns/direct_sms/",
    CONTACTS: "/bulk-communication/contacts/",
    REPORT: (id: string) => `/bulk-communication/campaigns/${id}/report/`,
    UPLOAD_CSV: (id: string) => `/bulk-communication/campaigns/${id}/upload-csv/`,
    DISPATCH: (id: string) => `/bulk-communication/campaigns/${id}/trigger-dispatch/`,
    RELAUNCH: (id: string) => `/bulk-communication/campaigns/${id}/relaunch/`,
    PAUSE: (id: string) => `/bulk-communication/campaigns/${id}/pause/`,
    DELETE: (id: string) => `/bulk-communication/campaigns/${id}/`,
  },
  DASHBOARD: {
    STATS: "/dashboard/stats",
    ACTIVITY: "/dashboard/activity",
    SUMMARY: "/dashboard/campaign-summary",
  },
  SALARY: {
    COMPONENTS: "/salary/components",
    STRUCTURES: "/salary/structures",
    ASSIGNMENT: "/salary/assign",
    PAYROLL: "/salary/payroll-run",
  },
  HEALTH: "/health",
  PUBLIC: {
    REGISTER: "/crm/public/register",
  },
  ACADEMICS: {
    DEPARTMENTS: "/academics/departments/",
    COURSES: "/academics/courses/",
  },
};
